import Vue from "vue";
import VueI18n from "vue-i18n";

// Localisation language list
import { locale as fa } from "@/core/config/i18n/fa";
import { locale as en } from "@/core/config/i18n/en";

Vue.use(VueI18n);

let messages = {};
messages = { ...messages, fa, en };

// get current selected language
const lang = localStorage.getItem("language") || "fa";

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  messages // set locale messages
});

export default i18n;
